import type { LunaClient } from '@vlabs/api-bindings';
import { apiContainer } from '@vlabs/api-bindings';

import { handlerMindigital } from '@vlabs/shared/payloads/handlers';

export interface EstimateMindigitalComplianceProps {
  handlerId: string;
  file?: File;
  raw?: boolean;
}

export type EstimateMindigitalComplianceReturn = Promise<Record<string, unknown> | undefined>;

export async function estimateMindigitalCompliance({
  handlerId,
  file,
  raw = false,
}: EstimateMindigitalComplianceProps): EstimateMindigitalComplianceReturn {
  if (!file || !handlerId) return undefined;
  const data = await (apiContainer.lunaClient as LunaClient).events.emit(
    handlerId,
    file,
    { policies: handlerMindigital.policies },
  );

  // eslint-disable-next-line no-underscore-dangle
  if (raw) return data._raw;

  if (data.events?.length > 0) return data.events[0];
  return data;
}
